





































import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import type { Cell, MergeValues, EBlockWidth } from '@getaccept/editor-lib';
import { Context } from '@getaccept/editor-lib';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { User } from '@getaccept/lib-shared/src/users/types/user';
import type { EditorRecipientInput } from '@getaccept/lib-shared/src/types/editor-recipient-input';
import type { PartiallySignedEvent } from '@getaccept/editor-lib/src/types/signed-field';
import EditorCell from './EditorCell.vue';

export default defineComponent({
  name: 'EditorRow',
  components: {
    EditorCell,
  },
  props: {
    cells: { type: Array as PropType<Cell[]>, default: () => [] },
    context: { type: String as PropType<Context>, default: () => Context.Document },
    mergeValues: {
      type: Object as PropType<MergeValues>,
      default: () => ({ document: {}, sender: {}, recipients: [], entity: {} }),
    },
    isPdfViewer: { type: Boolean },
    focusedRequiredId: { type: String, default: '' },
    blockWidthClass: {
      type: String as PropType<EBlockWidth>,
      default: null,
    },
    containsCoverImage: { type: Boolean },
    containsCoverVideo: { type: Boolean },
    pageWidth: { type: Number, default: 0 },
    isBlockToggled: { type: Boolean },
    isSigningSite: { type: Boolean },
    sender: {
      type: Object as PropType<User>,
      default: () => ({}),
    },
    recipient: {
      type: Object as PropType<Recipient>,
      default: () => ({}),
    },
    recipientInput: { type: Array as PropType<EditorRecipientInput[]>, required: true },
    updatingInputs: { type: Array as PropType<EditorRecipientInput[]>, required: true },
    failedInputUpdates: { type: Array as PropType<EditorRecipientInput[]>, required: true },
    partiallySignedFields: { type: Array as PropType<PartiallySignedEvent[]>, default: () => [] },
  },
});
